import { useCallback } from "react";

export const useUrlParam = (key) => {
  const setParam = useCallback((value) => {
    const params = new URLSearchParams(window.location.search);

    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }

    const query = params.toString();
    const newUrl = query
      ? `${window.location.pathname}?${query}`
      : window.location.pathname;

    window.history.replaceState({}, "", newUrl);
  }, [key]);

  const getParam = useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get(key);
  }, [key]);

  return { getParam, setParam };
};
